// extracted by mini-css-extract-plugin
export default {"group":"index_group__lO1Ye"};